import React from "react";

import { AccessionTable } from "@/features/accession/components/AccessionTable";
import { AccessionSearchContext } from "./SearchProvider";

export function SearchList({
  scrollRef,
}: {
  scrollRef: React.RefObject<HTMLDivElement | null>;
}) {
  const { items, isLoading } = React.useContext(AccessionSearchContext);
  return (
    <div className="@container">
      <AccessionTable
        accessions={items}
        isLoading={isLoading}
        scrollRef={scrollRef}
        scrollRestorationId="search-list"
      />
    </div>
  );
}
